// src/modules/app-views/_apps/appmulti/operators/pages/Document/decorators/response.js
// *******************************************************************************
// RESPONSE DECORATOR
// Transforms entity arrays into flat form-friendly fields so the form can
// populate CNPJ, email, phone and address inputs when loading an existing operator.
// *******************************************************************************

import entitiesService from 'services/entitiesService';

const decodeResponse = data => entitiesService.decodeResponse(data);

export default decodeResponse;
